import { COUPON_CONSTANTS } from "../constants/couponConstants";

const initialState = {
  coupons: [],
  couponUsers: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  },
  usersPagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  },
  loading: false,
  usersLoading: false,
  error: null,
  usersError: null
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case COUPON_CONSTANTS.FETCH_COUPONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case COUPON_CONSTANTS.FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.payload.response || action.payload,
        pagination: action.payload.pagination || state.pagination,
        error: null
      };
    case COUPON_CONSTANTS.FETCH_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case COUPON_CONSTANTS.FETCH_COUPON_USERS_REQUEST:
      return {
        ...state,
        usersLoading: true,
        usersError: null
      };
    case COUPON_CONSTANTS.FETCH_COUPON_USERS_SUCCESS:
      return {
        ...state,
        usersLoading: false,
        couponUsers: action.payload.response || action.payload,
        usersPagination: action.payload.pagination || state.usersPagination,
        usersError: null
      };
    case COUPON_CONSTANTS.FETCH_COUPON_USERS_FAILURE:
      return {
        ...state,
        usersLoading: false,
        usersError: action.payload
      };
    default:
      return state;
  }
};

export default couponReducer;